// The Wall of Love theme manifests.
//
// They used to sit beside their components in wall/public/*.jsx, which meant
// importing a theme's name pulled its whole component in. The wall editor only
// ever wants names, descriptions and compatibility counts, and the public wall
// page renders exactly one theme, but both were loading all twelve.
//
// `key` matches Wall#kind in the database, and Ruby mirrors the list in
// Wall::KINDS and Wall::KIND_COMPONENTS. test/models/wall_manifest_sync_test.rb
// parses this file and registry.jsx and fails when they drift apart.
//
// The compatibility helpers (proofIsCompatible, filterProofs,
// compatibilityCount) are shared with widgets and stay in
// widget/public/manifest.js. Only the data lives here.
//
// Array order is the theme picker's display order.
export const MANIFESTS = [
  // Cards.jsx
  {
    key: "cards",
    name: "Cards",
    description: "Clean editorial masonry of testimonial cards on a soft canvas.",
    kinds: ["text", "video", "audio"],
    requires: [],
    supportsInfiniteScroll: true,
  },
  // Bubbles.jsx
  {
    key: "bubbles",
    name: "Bubbles",
    description: "Soft pastel speech bubbles in a flowing column.",
    kinds: ["text", "video", "audio"],
    requires: [],
    supportsInfiniteScroll: true,
  },
  // Chats.jsx
  {
    key: "chats",
    name: "Chats",
    description: "iMessage-style conversation thread — receiver bubbles for testimonials.",
    kinds: ["text", "video", "audio"],
    requires: [],
    supportsInfiniteScroll: true,
  },
  // Futuristic.jsx
  {
    key: "futuristic",
    name: "Futuristic",
    description: "Neon glow, dark canvas, monospace accents — cyberpunk testimonial wall.",
    kinds: ["text", "video", "audio"],
    requires: [],
    supportsInfiniteScroll: true,
  },
  // QuoteGrid.jsx
  {
    key: "quotes",
    name: "Quotes",
    description: "Minimal text-only grid. Pure quotes in serif type with attribution.",
    kinds: ["text"],
    requires: [],
    supportsInfiniteScroll: true,
  },
  // Masonry.jsx
  {
    key: "masonry",
    name: "Masonry",
    description: "Pinterest-style masonry wall with mixed text, video and audio cards.",
    kinds: ["text", "video", "audio"],
    requires: [],
    supportsInfiniteScroll: true,
  },
  // TweetGrid.jsx
  {
    key: "tweets",
    name: "Tweets",
    description: "Twitter/X card replicas, for tweet-style social proof.",
    kinds: ["text", "video", "audio"],
    requires: [],
    supportsInfiniteScroll: true,
  },
  // TabbedWall.jsx
  {
    key: "tabbed",
    name: "Tabbed",
    description: "Proofs split into tabs so visitors can browse by type.",
    kinds: ["text", "video", "audio"],
    requires: [],
    supportsInfiniteScroll: true,
  },
  // PressWall.jsx
  {
    key: "press",
    name: "Press",
    description: "Logo-led press quotes in a restrained editorial grid.",
    kinds: ["text"],
    requires: ["source_platform"],
    supportsInfiniteScroll: true,
  },
  // ImageGallery.jsx
  {
    key: "gallery",
    name: "Gallery",
    description: "Masonry of imported testimonial screenshots.",
    kinds: ["text", "video", "audio"],
    requires: ["screenshot_url"],
    supportsInfiniteScroll: true,
  },
  // AudioWall.jsx
  {
    key: "audio",
    name: "Audio",
    description: "A wall of playable audio testimonials.",
    kinds: ["audio"],
    requires: ["audio_url"],
    supportsInfiniteScroll: true,
  },
  // VideoReels.jsx
  {
    key: "reels",
    name: "Reels",
    description: "TikTok-style portrait video tiles, hover to play.",
    kinds: ["video"],
    requires: ["video_url"],
    supportsInfiniteScroll: true,
  },
];

export const findManifest = (kind) =>
  MANIFESTS.find((m) => m.key === kind) || null;
